var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradientBlob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 577,
    height: 685,
    viewBox: "0 0 577 685",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63825 367.126C9.17638 324.612 24.4546 286.225 30.8646 244.079C41.3413 175.196 10.1836 91.2248 55.3917 40.0017C97.4466 -7.64875 176.359 -5.76734 236.002 11.648C292.617 28.1793 313.922 103.762 366.676 130.895C425.836 161.322 513.705 123.482 556.144 176.304C596.638 226.706 565.166 304.995 559.272 370.61C553.83 431.195 561.106 500.101 522.935 545.985C485.03 591.549 415.525 581.669 362.968 606.58C316.449 628.629 282.734 680.888 231.771 683.989C180.326 687.119 132.03 656.284 91.3977 623.104C53.5664 592.212 25.2563 549.799 9.36847 502.376C-5.13378 459.09 1.83386 412.84 5.63825 367.126Z",
    fill: "#161417"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBlob);
export default __webpack_public_path__ + "static/media/gradientBlob.7d4c5a5ad561d6088c05ab1077a2251f.svg";
export { ForwardRef as ReactComponent };